import { useEffect, useState } from "react";
import { Loader, SelectPicker } from "rsuite";
import { AppRouteApi } from "../../config/appRoute";
import { AxiosAuth } from "../../core/axios";
import { StorageAuth } from "../../core/localStorage";
import {
  ApiResponseContainer,
  ApiSchemaCompanyPaginated,
} from "../../models/api";

interface IProps {
  setSelectedCompany: (value: string, extra?: { companyName: string }) => void;
}

export function SelectCompany({ setSelectedCompany }: IProps) {
  const [isPending, setIsPending] = useState(false);
  const [dropdownData, setDropDownData] = useState<
    { label: string; value: string; companyName: string }[]
  >([]);
  const [selectedValue, setSelectedValue] = useState<string>("");

  useEffect(() => {
    const getData = async () => {
      setIsPending(true);
      try {
        const response = await AxiosAuth.get<
          ApiResponseContainer<ApiSchemaCompanyPaginated>
        >(AppRouteApi.Company.Root());
        const responseData = response.data;
        if (!responseData || !responseData.isSuccess) {
          return;
        }
        const dropdownData = responseData.data?.list.map((company) => ({
          label: company.name,
          value: company.sKey,
          companyName: company.name
        }));
        setDropDownData(dropdownData || []);

        // Set initial value from storage if it exists
        const storedCompanyId = StorageAuth.CompanyId;
        if (storedCompanyId) {
          setSelectedValue(storedCompanyId);
          const company = dropdownData?.find(c => c.value === storedCompanyId);
          if (company) {
            setSelectedCompany(storedCompanyId, { companyName: company.companyName });
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsPending(false);
      }
    };

    getData();
  }, [setSelectedCompany]);

  return (
    <>
      <SelectPicker
        value={selectedValue}
        onSelect={(value, item) => {
          setSelectedValue(value);
          setSelectedCompany(value, { companyName: (item as any)?.companyName });
        }}
        data={dropdownData}
        placeholder="Select a company"
        disabled={isPending}
        cleanable={false}
      />
      {isPending && <Loader size="sm" />}
    </>
  );
}
